import { combineReducers } from 'redux';
import { resettableReducer } from 'reduxsauce';
import { resetReducerKeys } from '../constants/app-constants';
import toastReducer from './toast/reducer';
import userReducer from './user/reducer';
import auctionsReducer from './auctions/reducer';
import searchReducer from './search/reducer';
import auctionDetailReducer from './auction-detail/reducer';
import ordersReducer from './orders/reducer';
import notificationReducer from './notification/reducer';
import watchListReducer from './watch-list/reducer';

const resettableToast = resettableReducer(resetReducerKeys.RESET_TOAST);
const resettableUser = resettableReducer(resetReducerKeys.RESET_USER);
const resettableAuctions = resettableReducer(resetReducerKeys.RESET_AUCTIONS);
const resettableSearch = resettableReducer(resetReducerKeys.RESET_SEARCH);
const resettableAuctionDetails = resettableReducer(resetReducerKeys.RESET_AUCTION_DETAILS);
const resettableOrders = resettableReducer(resetReducerKeys.RESET_ORDERS);
const resettableNotification = resettableReducer(resetReducerKeys.RESET_NOTIFICATIONS);
const resettableWatchList = resettableReducer(resetReducerKeys.RESET_WATCH_LIST);

export default combineReducers({
    toast: resettableToast(toastReducer),
    user: resettableUser(userReducer),
    auctions: resettableAuctions(auctionsReducer),
    search: resettableSearch(searchReducer),
    auctionDetail: resettableAuctionDetails(auctionDetailReducer),
    orders: resettableOrders(ordersReducer),
    notification: resettableNotification(notificationReducer),
    watchList: resettableWatchList(watchListReducer)
});